// extracted by mini-css-extract-plugin
module.exports = {"dot":"trCNRCyC"};